/* ==========================================================================
   Accessibility button in the announcement bar -> UserWay.

   UserWay is installed as an app embed and draws its own floating button in
   the top-right corner. The mockup puts a small accessibility glyph at the
   end of the top bar instead, so the theme renders that glyph
   (announcement-bar.liquid), hides UserWay's floating icon with CSS, and this
   file makes the glyph open the same widget.

   UserWay exposes window.UserWay.widgetOpen() once its script has booted,
   which can be well after ours: it loads from its own CDN, deferred. So a
   click that lands before that just waits for it (polling briefly) instead
   of doing nothing. Nothing here touches UserWay's configuration -- the app
   keeps working exactly as installed if this button is ever switched off.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- where the glyph sits ------------------------------------------------
     The mockup centres it in the space to the right of the message, which
     giorgio-header-refresh.css works out from the message's width. Only the
     browser knows that width -- it depends on the text the client typed, the
     font and the letter-spacing setting -- so it is measured here and handed
     over as a custom property.

     The WIDEST message wins, not the one showing: the announcements rotate,
     and a glyph that slid left and right every few seconds would be worse than
     one a few pixels off. Measured again on resize and once the webfont has
     loaded, since the line reflows in both cases. */
  function sizeGlyph() {
    var bar = document.querySelector('.gio-bar--a11y');
    if (!bar) return;
    var messages = bar.querySelectorAll('.announcement-bar__message');
    var widest = 0;
    for (var i = 0; i < messages.length; i++) {
      var span = messages[i].querySelector('span') || messages[i];
      widest = Math.max(widest, span.getBoundingClientRect().width);
    }
    if (widest > 0) bar.style.setProperty('--gio-bar-msg-w', Math.round(widest) + 'px');

    /* The tools group's own width, for pages whose bar also carries the
       search / account / cart cluster: there the group is pinned to the
       corner and can be 300px+ wide, so the message container is given that
       much right padding and slides left of it instead of under it. */
    var tools = bar.querySelector('.gio-bar-tools');
    if (tools) bar.style.setProperty('--gio-bar-tools-w', Math.round(tools.getBoundingClientRect().width) + 'px');

    /* Is there room for the centred layout at all? The mockup's geometry was
       drawn for a lone 30px glyph; with Wholesale beside it the group is
       ~170px, and below roughly 1200px the group's left end reaches the
       message. So the centred layout is tried first and measured: if the
       group would touch the message, the bar switches to its "tight" layout
       (group pinned to the corner, message padded away from it -- the same
       rules the icon-cluster pages use). Re-run on every resize. */
    if (tools && window.innerWidth >= 990) {
      bar.classList.remove('gio-bar--tight');
      /* Only the slide on screen counts. Dawn's announcement slider lays the
         slides out in a row and scrolls between them, so the others sit off
         to the right, outside the window -- measuring those said "collision"
         at every width and pinned the group everywhere. Dawn marks them
         aria-hidden. */
      var msgRight = 0;
      for (var k = 0; k < messages.length; k++) {
        var slide = messages[k].closest('.slider__slide, .slideshow__slide');
        if (slide && slide.getAttribute('aria-hidden') === 'true') continue;
        var sp = messages[k].querySelector('span') || messages[k];
        var rr = sp.getBoundingClientRect();
        if (rr.width && rr.left < window.innerWidth) msgRight = Math.max(msgRight, rr.right);
      }
      var toolsLeft = tools.getBoundingClientRect().left;
      if (msgRight && toolsLeft < msgRight + 16) bar.classList.add('gio-bar--tight');
    } else {
      bar.classList.remove('gio-bar--tight');
    }
  }

  var pending;
  function scheduleSize() {
    window.clearTimeout(pending);
    pending = window.setTimeout(sizeGlyph, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sizeGlyph, { once: true });
  } else {
    sizeGlyph();
  }
  window.addEventListener('resize', scheduleSize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeGlyph);

  function open() {
    if (window.UserWay && typeof window.UserWay.widgetOpen === 'function') {
      window.UserWay.widgetOpen();
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('#gioA11yTrigger');
    if (!btn) return;
    event.preventDefault();
    if (open()) return;

    // Not booted yet: try again every 250ms for up to ten seconds.
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (open() || tries > 40) clearInterval(timer);
    }, 250);
  });
})();
